import { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import { AppShell } from './components/layout'

// Lazy load pages - only loads when navigated to
const AuthCallbackPage = lazy(() => import('./pages/AuthCallback'))
const DashboardPage = lazy(() => import('./pages/Dashboard'))
const AutomationsPage = lazy(() => import('./pages/Automations'))
const TracesPage = lazy(() => import('./pages/Traces'))
const ErrorsPage = lazy(() => import('./pages/Errors'))
const TestCasesPage = lazy(() => import('./pages/TestCases'))
const ActivityPage = lazy(() => import('./pages/Activity'))
const AlertsPage = lazy(() => import('./pages/Alerts'))
const TicketsPage = lazy(() => import('./pages/Tickets'))
const TestSuitesPage = lazy(() => import('./pages/TestSuites'))
const CoveragePage = lazy(() => import('./pages/Coverage'))
const UsersPage = lazy(() => import('./pages/Users'))
const PromptTestsPage = lazy(() => import('./pages/PromptTests'))
const ServicesPage = lazy(() => import('./pages/Services'))

// Simple loading fallback
function PageLoader() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-sm text-gray-500">Loading...</div>
    </div>
  )
}

export default function App() {
  return (
    <Routes>
      {/* Auth callback - outside AppShell */}
      <Route
        path="/auth/callback"
        element={
          <Suspense fallback={<PageLoader />}>
            <AuthCallbackPage />
          </Suspense>
        }
      />
      <Route path="/" element={<AppShell />}>
        <Route
          index
          element={
            <Suspense fallback={<PageLoader />}>
              <DashboardPage />
            </Suspense>
          }
        />
        <Route
          path="automations"
          element={
            <Suspense fallback={<PageLoader />}>
              <AutomationsPage />
            </Suspense>
          }
        />
        <Route
          path="automations/:automationId"
          element={
            <Suspense fallback={<PageLoader />}>
              <AutomationsPage />
            </Suspense>
          }
        />
        <Route
          path="traces"
          element={
            <Suspense fallback={<PageLoader />}>
              <TracesPage />
            </Suspense>
          }
        />
        <Route
          path="traces/:traceId"
          element={
            <Suspense fallback={<PageLoader />}>
              <TracesPage />
            </Suspense>
          }
        />
        <Route
          path="errors"
          element={
            <Suspense fallback={<PageLoader />}>
              <ErrorsPage />
            </Suspense>
          }
        />
        <Route
          path="errors/:errorId"
          element={
            <Suspense fallback={<PageLoader />}>
              <ErrorsPage />
            </Suspense>
          }
        />
        <Route
          path="test-cases"
          element={
            <Suspense fallback={<PageLoader />}>
              <TestCasesPage />
            </Suspense>
          }
        />
        <Route
          path="test-cases/:testId"
          element={
            <Suspense fallback={<PageLoader />}>
              <TestCasesPage />
            </Suspense>
          }
        />
        <Route
          path="activity"
          element={
            <Suspense fallback={<PageLoader />}>
              <ActivityPage />
            </Suspense>
          }
        />
        <Route
          path="alerts"
          element={
            <Suspense fallback={<PageLoader />}>
              <AlertsPage />
            </Suspense>
          }
        />
        <Route
          path="alerts/:ruleId"
          element={
            <Suspense fallback={<PageLoader />}>
              <AlertsPage />
            </Suspense>
          }
        />
        <Route
          path="tickets"
          element={
            <Suspense fallback={<PageLoader />}>
              <TicketsPage />
            </Suspense>
          }
        />
        <Route
          path="tickets/:ticketId"
          element={
            <Suspense fallback={<PageLoader />}>
              <TicketsPage />
            </Suspense>
          }
        />
        <Route
          path="test-suites"
          element={
            <Suspense fallback={<PageLoader />}>
              <TestSuitesPage />
            </Suspense>
          }
        />
        <Route
          path="test-suites/:suiteId"
          element={
            <Suspense fallback={<PageLoader />}>
              <TestSuitesPage />
            </Suspense>
          }
        />
        <Route
          path="prompt-tests"
          element={
            <Suspense fallback={<PageLoader />}>
              <PromptTestsPage />
            </Suspense>
          }
        />
        <Route
          path="prompt-tests/:promptTestId"
          element={
            <Suspense fallback={<PageLoader />}>
              <PromptTestsPage />
            </Suspense>
          }
        />
        <Route
          path="coverage"
          element={
            <Suspense fallback={<PageLoader />}>
              <CoveragePage />
            </Suspense>
          }
        />
        <Route
          path="users"
          element={
            <Suspense fallback={<PageLoader />}>
              <UsersPage />
            </Suspense>
          }
        />
        <Route
          path="services"
          element={
            <Suspense fallback={<PageLoader />}>
              <ServicesPage />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  )
}
